import getOrangeKitXverseConnector from "./connector";
export function getXverseWallet(config) {
    return () => ({
        id: "orangekit-xverse",
        name: "OrangeKit Xverse",
        iconUrl: "https://www.svgrepo.com/show/74027/orange.svg",
        iconAccent: "#1E1E1E",
        iconBackground: "#1E1E1E",
        installed: !!window.XverseProviders?.BitcoinProvider,
        createConnector: getOrangeKitXverseConnector(config),
        downloadUrls: {
            desktop: "https://www.xverse.app/download",
        },
    });
}
//# sourceMappingURL=rainbowkit-wallet.js.map